import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { DatablockItemEntity } from '../components/datablock-list/datablock-item.entity';
import { DatablockListEntity } from '../components/datablock-list/datablock-list.entity';
import {
	DatablockSliceKey,
	DatablockOriginalSliceState,
} from './datablock.state';
import { DatablockRootState, featureSelector } from './feature.store';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[DatablockSliceKey]
);

@Injectable()
export class DatablockSelector {
	public constructor(private readonly store: Store<DatablockRootState>) {}

	private get state(): Observable<DatablockOriginalSliceState> {
		return this.store.pipe(select(baseSelector));
	}
	public getLoading$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('loading')));
	}
	public getLoadingPersistence$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('isLoadingPersistence')));
	}

	public getDatablockList$(): Observable<DatablockListEntity> {
		return this.state.pipe(map((state) => state.get('list')));
	}

	public includePublic$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('includePublicProjects')));
	}

	public getSelectedDatablocks$(
		selected: Array<string>
	): Observable<Array<DatablockItemEntity>> {
		return this.getDatablockList$().pipe(
			map((list) =>
				selected.reduce<Array<DatablockItemEntity>>((acc, curr) => {
					const maybe = list.elements.get(`${curr}`);
					if (maybe) {
						acc.push(maybe);
						return acc;
					}
					return acc;
				}, [])
			)
		);
	}
}
